/**
 * @fileoverview Logo Component - Irish Funds company logo
 * 
 * Provides the Irish Funds company logo for header display:
 * - Consistent branding across application
 * - Responsive image sizing
 * - Accessibility attributes
 * - Professional brand presentation
 * 
 * @component
 * @example
 * <Logo />
 * 
 * @requires React
 * 
 * @author By John Bellew - Infinia.ie - last updated 10/07/2025
 */

import React from 'react';

/**
 * Logo Component
 * 
 * Renders the Irish Funds company logo for header display.
 * 
 * @component
 * @returns {JSX.Element} Irish Funds logo image
 */
const Logo = () => {
  return (
    <div className="logo">
      <img src="/assets/img/irish-logo.png" alt="Irish Funds Logo" />
    </div>
  );
};

export default Logo; 